/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_SubmitInputs */

const en_fw_pub_submit = /** @type {(inputs: Fw_Pub_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const id_fw_pub_submit = /** @type {(inputs: Fw_Pub_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Fw_Pub_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_submit = /** @type {((inputs?: Fw_Pub_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_submit(inputs)
	return en_fw_pub_submit(inputs)
});